import React, { useEffect, useState } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';
import { getEntity, deleteEntity } from './par-type-prise-en-charge.reducer'; // Assurez-vous que le chemin est correct

export const ParTypePriseEnChargeDeleteDialog = (props: RouteComponentProps<{ id: string }>) => {
  const [loadModal, setLoadModal] = useState(false);
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getEntity(props.match.params.id));
    setLoadModal(true);
  }, [dispatch, props.match.params.id]);

  const parTypePriseEnChargeEntity = useAppSelector(state => state.parTypePriseEnCharge.entity);
  const updateSuccess = useAppSelector(state => state.parTypePriseEnCharge.updateSuccess);

  const handleClose = () => {
    props.history.push('/par-type-prise-en-charge');
  };

  useEffect(() => {
    if (updateSuccess && loadModal) {
      handleClose();
      setLoadModal(false);
    }
  }, [updateSuccess, loadModal, handleClose]);

  const confirmDelete = () => {
    dispatch(deleteEntity(parTypePriseEnChargeEntity.id));
  };

  return (
    <Modal isOpen toggle={handleClose}>
      <ModalHeader toggle={handleClose} data-cy="parTypePriseEnChargeDeleteDialogHeading">
        <Translate contentKey="entity.delete.title">Confirm delete operation</Translate>
      </ModalHeader>
      <ModalBody id="almobadaraMasterDataApp.parTypePriseEnCharge.delete.question">
        <Translate
          contentKey="almobadaraMasterDataApp.parTypePriseEnCharge.delete.question"
          interpolate={{ id: parTypePriseEnChargeEntity.id }}
        >
          Are you sure you want to delete this ParTypePriseEnCharge?
        </Translate>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={handleClose}>
          <FontAwesomeIcon icon="ban" />
          &nbsp;
          <Translate contentKey="entity.action.cancel">Cancel</Translate>
        </Button>
        <Button id="jhi-confirm-delete-parTypePriseEnCharge" data-cy="entityConfirmDeleteButton" color="danger" onClick={confirmDelete}>
          <FontAwesomeIcon icon="trash" />
          &nbsp;
          <Translate contentKey="entity.action.delete">Archive</Translate>
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default ParTypePriseEnChargeDeleteDialog;
